export const onlyNumbers = (value) => /^[0-9\b]+$/.test(value)
export const onlyEmail = (value) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w\w+)+$/.test(value)
// min 8 char, max 13 char, contain letter & number
export const regexPassword = (value) => /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,13}$/.test(value)
